import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const tabs = ["Home", "Experience", "Education", "Projects", "Contact"];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar navbar-expand-lg portfolio-nav sticky-top">
      <div className="container">
        <NavLink className="navbar-brand" to="/" onClick={() => setIsOpen(false)}>
          <span className="accent">Isaac</span> Mills-Owoo
        </NavLink>
        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}>
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 gap-1">
            {tabs.map((tab) => (
              <li className="nav-item" key={tab}>
                <NavLink
                  to={`/${tab === "Home" ? "" : tab.toLowerCase()}`}
                  className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
                  onClick={() => setIsOpen(false)}
                >
                  {tab}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
